import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { ExternalLink } from '../../theme'

import Tooltip from '../Tooltip/TooltipStyle'
import CopyToClipboard from 'react-copy-to-clipboard'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 72px;
  margin: 0 auto;
  justify-content: center;
`
const CommunityLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.bsText2};
  font-family: Baloo Da;
  &:not(:last-child) {
    margin-right: 32px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      margin-right: 10px;
    `}
  }
`
const Email = styled.div`
  color: ${({ theme }) => theme.bsText2};
  cursor: pointer;
  font-family: Baloo Da;
  white-space: nowrap;
`

export default function BodyFooter() {
  const [show, setShow] = useState<boolean>(false)
  const [copied, setCopid] = useState<boolean>(false)
  const copy = useCallback(() => setCopid(true), [setCopid])
  const open = useCallback(() => setShow(true), [setShow])
  const close = useCallback(() => {
    setShow(false)
    setCopid(false)
  }, [setShow])

  return (
    <Wrapper>
      <CommunityLink href="https://twitter.com/bakery_swap">Twitter</CommunityLink>
      <CommunityLink href="https://t.me/bakeryswap">Telegram</CommunityLink>
      <CommunityLink href="https://medium.com/@BakerySwap">Medium</CommunityLink>
      <CommunityLink href="https://github.com/BakeryProject">Github</CommunityLink>
      <Tooltip text={ copied ? 'Email Copied!' : 'contact@bakeryswap.org'} width={copied ? 110 : 180} show={show} placement='top'>
        <CopyToClipboard
          text='contact@bakeryswap.org'
          onCopy={copy}
        >
          <Email
            onMouseEnter={open}
            onMouseLeave={close}
          >Contact us</Email>
        </CopyToClipboard>
      </Tooltip>
    </Wrapper>
  )
}